<template>
  <div id="index" class="index">
    <div class="companyProfile">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="['Company-Details', { active: selectNumber == index }]"
        @click="clickType(item, index)"
      >
        {{ item.title }}
      </div>
    </div>
    <CompanyDetails v-if="selectNumber == 0" />
    <Users v-if="selectNumber == 1" />
  </div>
</template>

<script>
import CompanyDetails from './companyDetails.vue'
import Users from './users.vue'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    CompanyDetails,
    Users
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      tabList: [
        {
          title: '公司详情'
        },
        {
          title: '用户'
        }
      ],
      selectNumber: 0
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  mounted() {
    // 页面进入时加载内容
  },
  created() {
    // 实例被创建之后执行代码
  },
  methods: {
    clickType(item, index) {
      this.selectNumber = index
    }
  }
}
</script>
<style scoped lang="scss">
.companyProfile {
  display: flex;
  justify-content: start;
	align-items: center;
	width: 160px;
  height: 48px;
	padding: 0 8px;
  background: rgba(221, 221, 221, 0.32);
  border-radius: 8px;
	box-sizing: border-box;

  .Company-Details,
  .Users {
		white-space: nowrap;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #777777;
    margin-right: 16px;
    line-height: 32px;
    cursor: pointer;
		padding: 0 8px;
		transition: all 0.3s;
  }

	.Users {
		margin-left: 8px;
	}

  .active {
    // max-width: 145px;
    // min-width: 59px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #3370ff !important;

  }
}
</style>
